<template>
  <div>
    <YearsComponent @change="onYearSelected" />
  </div>
</template>

<script>
import YearsComponent from "@/components/Global_System/YearsComponent";

export default {
  name: "ReportByProductByMonthFilters",
  components: {
    YearsComponent
  },
  methods: {
    onYearSelected(year) {
      console.log("onYearSelected 0: ", year);
      this.$emit("onYearSelected", year);
    }
  }
};
</script>

<style lang="scss" scoped></style>
